// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__AYPF+","title":"ModalHeader_title__-Jami","close":"ModalHeader_close__bzubv"};